import React, { useState, useEffect } from "react";
import JoinNow from "../../pages/lobby/joinNow";
import _ from "lodash";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Socket from "../../socket/socket";
import * as loaderAction from "../../redux/loader/action";
import * as paramsAction from "../../redux/gameParams/actions";
import Alert from "../shared/common/alert";
import { Container, Row, Col } from "reactstrap";
import userImg from "../../assets/images/bingo/user-img.png";
import crossIcon from "../../assets/images/bingo/cross-icon.png";
import chevronDown from "../../assets/images/bingo/chevron-down.png";
import chevronUp from "../../assets/images/bingo/chevron-up.png";
import BingoUsers from "./BingoUsers";
import startBtn from "../../assets/images/bingo/start-play-btn.png";
import timed_game_switch from "../../assets/images/bingo/timed_game_switch.png";

const Bingo = (props) => {
  const { onBack, branchLink } = props;
  const parameters = _.get(props, "paramsReducer.gameObj.1_joining");
  const roomData = _.get(props, "gameReducer.roomObj");
  let prev_timed_game = roomData?.game_state?.game_parameters?.timed;
  const users = _.get(roomData, "users");
  const gameName = _.get(props, "gameReducer?.gameName");
  const status = _.get(roomData, "game_state.status");
  const [timedGame, settimedGame] = useState(false);
  const [timeBetweenDropdown, settimeBetweenDropdown] = useState(false);
  const [winPatternDropdown, setwinPatternDropdown] = useState(false);
  const [gameTimer, setgameTimer] = useState(10);
  const [winPattern, setwinPattern] = useState("Any 1 line");
  const [timedGameButtonClass, settimedGameButtonClass] = useState("off");
  const timer = _.get(roomData, "lobby_parameters.timer", 10);
  const timed_game = _.get(roomData, "lobby_parameters.timed_game", false);
  const win_pattern = _.get(roomData, "lobby_parameters.win_pattern");

  useEffect(() => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      win_pattern: winPattern
    };
    Socket.sendMessage(data);
  }, [winPattern]);

  useEffect(() => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      timer: gameTimer
    };
    Socket.sendMessage(data);
  }, [gameTimer]);

  useEffect(() => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      timed_game: timedGame
    };
    Socket.sendMessage(data);
  }, [timedGame]);

  const onStartGame = () => {
    if (users && users.length < 2) {
      Alert(400, "Need at least 2 players to start the game");
      return;
    } else {
      // props.setIsLoading(true);
      let data = {
        action: "update-status",
        roomId: roomData.id,
        tableTopName: "Bingo",
        timed: timedGame,
        timer: gameTimer,
        win_pattern: winPattern
      };
      Socket.sendMessage(data);
      props.history.push("/bingo");
    }
  };
  const toggleTimedGame = () => {
    settimedGame(!timedGame);
  };

  return (
    <div className="bingo-lobby">
      {/* <img src={bingo_background_image} /> */}
      <div className="bingo-lobby-main-content">
        <Container fluid>
          <Row className="p-4 p-md-0 BNG-row">
            <Col sm={3} className="px-2">
              <JoinNow
                link={branchLink}
                type="BNG"
                className="BNG-card barcode"
                joinCodeTextClassName="scan_text"
                BNG
                onBack={onBack}
              />
            </Col>
            <Col sm={9} className="px-2">
              {/* <div className="htplay h-100 teams"></div> */}
              <div className="bingo-players-wrapper">
                <BingoUsers />
                <div className="players-footer">
                  <div className="players-footer-btns">
                    <div className="players-footer-btn">
                      {winPatternDropdown ? (
                        <>
                          <h3>{parameters?.win_label}</h3>
                          <button className="seconds-btn-dropdown">
                            <p
                              onClick={() => {
                                setwinPattern(parameters.win_list[0]);
                                setwinPatternDropdown(false);
                              }}
                              className="second"
                            >
                              {parameters.win_list[0]}
                            </p>
                            <p
                              onClick={() => {
                                setwinPattern(parameters.win_list[1]);
                                setwinPatternDropdown(false);
                              }}
                              className="second"
                            >
                              {parameters.win_list[1]}
                            </p>
                            <img
                              src={chevronDown}
                              onClick={() => setwinPatternDropdown(false)}
                              alt="down"
                            />
                          </button>
                        </>
                      ) : (
                        <>
                          <h4 className="common-heading-win-pattern">
                            Win Pattern
                          </h4>
                          <button className="seconds-btn any-line">
                            {win_pattern}
                            <img
                              src={chevronDown}
                              onClick={() => setwinPatternDropdown(true)}
                              alt="down"
                            />
                          </button>
                        </>
                      )}
                    </div>
                    <div className="players-footer-btn timed-game-box ">
                      <h4 className="common-heading">TIMED GAME</h4>
                      <label class="on-off-toggle">
                        <input type="checkbox" id="togBtn" />
                        <div
                          class="slider round"
                          onClick={() => toggleTimedGame()}
                        >
                          {timed_game ? (
                            <span name="on" class="on">
                              <img
                                src={timed_game_switch}
                                alt="on"
                                className="on-img"
                              ></img>
                              <span className="on-text">ON</span>
                            </span>
                          ) : (
                            <span name="off" class="off">
                              <img
                                src={timed_game_switch}
                                alt="on"
                                className="off-img"
                              ></img>
                              OFF
                            </span>
                          )}
                        </div>
                      </label>
                    </div>
                    {timed_game && (
                      <div className="players-footer-btn">
                        {timeBetweenDropdown ? (
                          <>
                            <h3>time between</h3>
                            <button className="seconds-btn-dropdown time-bt-drp">
                              <p
                                onClick={() => {
                                  setgameTimer(30);
                                  settimeBetweenDropdown(false);
                                }}
                                className="second"
                              >
                                30 sec
                              </p>
                              <p
                                onClick={() => {
                                  setgameTimer(20);
                                  settimeBetweenDropdown(false);
                                }}
                                className="second"
                              >
                                20 sec
                              </p>
                              <p
                                onClick={() => {
                                  setgameTimer(10);
                                  settimeBetweenDropdown(false);
                                }}
                                className="second"
                              >
                                10 sec
                              </p>{" "}
                              <img
                                src={chevronDown}
                                onClick={() => settimeBetweenDropdown(false)}
                                alt="down"
                              />
                            </button>
                          </>
                        ) : (
                          <>
                            <h4 className="common-heading">time between</h4>
                            <button className="seconds-btn">
                              {timer} sec
                              <img
                                src={chevronDown}
                                onClick={() => settimeBetweenDropdown(true)}
                                alt="down"
                              />
                            </button>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                  <button
                    className="players-footer-start-btn"
                    onClick={onStartGame}
                  >
                    Start <img src={startBtn} alt="start button" />
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});
const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    getGameData: (data) => dispatch(paramsAction.getGameData(data))
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Bingo);
